import React from 'react';
interface ActionCardProps {
  icon: ReactNode;
  title: string;
  onClick: () => void;
  color: string;
  subAction?: {
    label: string;
    onClick: () => void;
  };
}
export const ActionCard = ({
  icon,
  title,
  onClick,
  color,
  subAction
}: ActionCardProps) => {
  return <div className={`rounded-md overflow-hidden shadow-sm`} data-id="element-80">
      <button onClick={onClick} className={`w-full h-20 flex items-center px-4 text-white ${color} transition-colors duration-150 hover:opacity-90`} data-id="element-81">
        <div className="flex items-center justify-center w-10 h-10 mr-3" data-id="element-82">
          {icon}
        </div>
        <span className="font-medium" data-id="element-83">{title}</span>
      </button>
      {subAction && <button onClick={subAction.onClick} className="w-full bg-gray-100 text-gray-600 py-2 text-sm hover:bg-gray-200 flex justify-center items-center" data-id="element-84">
          {subAction.label}
        </button>}
    </div>;
};